export default {
  10001: "Veuillez entrer votre nom d'utilisateur ou votre adresse e-mail",
  10002: 'E-mail mal saisi',
  10003: "erreur de saisie du nom d'utilisateur",
  10004: 'Mot de passe mal saisi',
  10005: 'Statut utilisateur anormal',
  10006: "Ce nom d'utilisateur existe déjà",
  10007: "l'email existe déjà",
  10008: "Le statut de l'utilisateur est incorrect",
  10009: 'Aucun utilisateur correspondant trouvé',
  10010: 'Le produit Expert Advisor est incorrect',
  10011:
    "Si le solde de l'utilisateur est insuffisant, veuillez recharger ou débloquer le dépôt avant d'effectuer un achat.",
  10012: 'Aucun jour correspondant trouvé',
  10013: "Le montant de l'investissement est erroné",
  10014: 'Le produit de règlement quantitatif est incorrect',
  10015: 'Non disponible actuellement à la négociation',
  10016: "Montant d'achat incorrect",
  10017: 'Aucune période correspondante trouvée',
  10018: "Échec de l'obtention des paramètres système",
  10019: "Le statut d'authentification actuel de cet utilisateur est incorrect",
  10020: "L'état de la collecte est incorrect",
  10021: 'Adresse de réception non renseignée',
  10022: "L'utilisateur n'est pas authentifié",
  10023: 'La durée du prêt est mal réglée',
  10024: "Vous avez déjà acheté le même produit, veuillez ne pas l'acheter à nouveau",
  10025: 'Veuillez sélectionner une méthode de retrait',
  10027: 'Le montant du prêt ne peut pas être vide',
  10028: 'La durée du prêt ne peut pas être vide',
  10029: 'Le montant du prêt doit être supérieur à 0',
  10030: "La configuration de la durée du prêt n'existe pas",
  10031: 'Le montant du prêt est inférieur au minimum',
  10032: 'Le montant du prêt dépasse le maximum',
  10033: "L'identifiant de l'enregistrement du prêt ne peut pas être vide",
  10034: "L'enregistrement du prêt n'existe pas",
  10035: "Vous n'avez pas la permission de manipuler cet enregistrement de prêt",
  10036: 'Le statut du prêt ne permet pas le remboursement',
  10037: 'Solde de compte insuffisant',
  10108: 'Actions US hors séance (lun–ven 9h30–16h HE). Veuillez réessayer plus tard.',
  10109: 'Forex/métaux précieux hors séance (dim 17h–ven 17h HE). Veuillez réessayer plus tard.',
  10110: 'Quantité de trading invalide. Veuillez saisir une valeur supérieure à 0.',
  20001: 'Soumission pour examen réussie',
  20002: 'Recharge ajoutée avec succès et soumise pour examen',
  20003: 'Retrait ajouté avec succès et soumis pour examen',
  20004: 'Achat réussi',
  20005: 'Modification réussie',
  20024: "Vous avez déjà acheté le même produit, veuillez ne pas l'acheter à nouveau",
  20102:
    'Votre compte a été gelé. Le trading et les retraits sont temporairement indisponibles. Veuillez contacter le support pour toute question.',
  20103: 'Votre session a expiré. Veuillez vous reconnecter.',
  20104: "Vous n'êtes pas connecté. Veuillez vous connecter.",
  Invite: {
    CopyLink: 'Copier le lien',
    FillInAccount: 'Remplissez le formulaire en ligne et ouvrez un compte de trading',
    Fund: 'Financer',
    FundYourPrefer: 'Financez votre compte via les méthodes de financement de votre choix',
    InviteFriends: 'Inviter des amis',
    InviteYourFriends: 'Invitez vos amis',
    Register: "S'inscrire",
    StartTradingPlatform: 'Commencez à trader avec notre plateforme de trading primée',
    Trade: 'Trader',
    WhenYourRewards:
      'Invitez vos amis et votre famille à nous rejoindre, et récoltez ensemble les récompenses tout en vous lançant dans un voyage vers la prospérité financière !',
  },
  Market: {
    CreateAPlanToTrade: 'Créer un plan de trading',
    ETF: 'ETF',
    ExpectedReturn: 'Rendement attendu',
    LastPrice: 'Dernier prix',
    Lots: 'Lots',
    OpenPrice: "Prix d'ouverture",
    OrderAgain: 'Commander à nouveau',
    OrderNumber: 'Numéro de commande',
    Price: 'Prix',
    Prices: 'Prix...',
    Sizes: 'Taille...',
    SpotPrice: 'Prix spot',
    StopLossPrices: 'Prix de stop-loss...',
    TakeProfitPrices: 'Prix de prise de profit...',
    WantMoreStableEarning: 'Voulez-vous des gains plus stables ?',
    WhatIsSmartTrading: "Qu'est-ce que le trading intelligent",
    available: 'Disponible',
    buy: 'Acheter',
    buyLong: 'Acheter long',
    buyLongBtn: 'Acheter long',
    chart: 'Graphique',
    checkoutSuccess: 'Paiement réussi',
    close: 'Fermeture',
    confirm: 'Confirmer',
    contracts: 'Contrats',
    create: 'Créer',
    cypto: 'Crypto',
    day: 'jour',
    down: 'Baisse',
    estimation: 'Estimation',
    forex: 'Forex',
    free: 'Frais',
    frees: 'Gratuit',
    futures: 'Matières premières',
    high: 'Haut',
    hour: 'heure',
    investment: 'Investissement',
    leverage: 'Effet de levier',
    limit: 'Limite',
    low: 'Bas',
    market: 'Marché',
    min: 'min',
    mon: 'mois',
    name: 'Nom',
    notOpen: "La fonction n'est pas encore ouverte",
    open: 'Ouverture',
    options: 'Règlement quantitatif',
    optionsTime: 'Durée de règlement',
    orderConfirm: 'Confirmation de commande',
    requiredMargin: 'Marge requise',
    return: 'Retour',
    sell: 'Vendre',
    sellShort: 'Vendre à découvert',
    sellShortBtn: 'Vendre à découvert',
    stocks: 'Actions',
    stopLoss: 'Stop loss',
    stopLossPrice: 'Prix du stop loss',
    takeProfit: 'Prendre des bénéfices',
    takeProfitPrice: 'Prix de prise de bénéfice',
    time: 'Heure',
    up: 'Hausse',
    volume: 'Volume',
    watchlist: 'Liste de surveillance',
    week: 'semaine',
  },
  SmartTrading: {
    InterInvestmentAmount: "Montant d'investissement intermédiaire...",
    SelectATimeframe: 'Sélectionner une période',
    create: 'Créer',
    createAPlan: 'Créer un plan',
    dailyYield: 'Rendement quotidien',
    days: 'Jours',
    investment: 'Investissement',
    investmentRange: 'Montant limite',
    product: 'Produit',
    smrtTrading: 'Trading intelligent',
    timeframe: 'Période',
  },
  aboutUs: {
    about: 'À propos de nous',
    subtitle1: "Profil de l'entreprise",
    subtitle2: 'Partenaire',
    title: 'À propos de {title}',
  },
  account: {
    BTCAmount: 'Montant',
    LOTS: 'LOTS',
    LastDigits: 'Derniers 6 chiffres',
    Lots: 'Lots',
    PaymentAmount: 'Montant du paiement',
    PleaseUploadSubmission:
      "Veuillez télécharger une capture d'écran de votre paiement en cryptomonnaie et attendre la vérification après soumission",
    Preview: 'Aperçu',
    SelectImage: 'Sélectionner une image',
    Supports: 'Prise en charge des formats : JPG, JPEG2000, PNG',
    TransactionHash: 'Hachage de transaction',
    UploadProof: 'Télécharger une preuve',
    UploadYourScreenshot: "Télécharger la capture d'écran de votre transfert",
    accountVerification: 'Vérification du compte',
    address: 'Adresse',
    allOrders: 'Tous les ordres',
    amount: 'Montant',
    approved: 'Approuvé',
    balance: 'Solde',
    buy: 'ACHETER',
    cancel: 'Annuler',
    changeLanguage: 'Changer de langue',
    changePassword: 'Changer de mot de passe',
    close: 'Fermer',
    closePrice: 'Prix de clôture',
    closeTime: 'Heure de fermeture',
    closed: 'Fermé',
    contactUs: 'Contactez-nous',
    copyAddress: "Copier l'adresse",
    copySuccess: 'Copié avec succès',
    cycle: 'Cycle',
    dailyRor: 'Taux de rendement journalier',
    demo: 'Démo',
    deposit: 'Dépôt',
    depositWithdraw: 'Dépôt et retrait',
    down: 'Bas',
    downloadPDF: 'Télécharger le PDF',
    earlyExist: 'Sortie anticipée',
    earlyExit: 'Sortie anticipée',
    earlyExitTip:
      'Si la transaction est arrêtée prématurément, le système déduira automatiquement {num} du capital à titre de dommages et intérêts, et vos revenus totaux seront déduits.',
    expandMore: 'Afficher plus',
    expirationTime: "Heure d'expiration",
    failed: 'Échec',
    freeMargin: 'Marge utilisée',
    futures: 'Futures',
    helpCenter: "Centre d'aide (FAQ)",
    inviteFriends: 'Invitez vos amis',
    lastPrice: 'Dernier prix',
    lever: 'Effet de levier',
    liquidatedDamages: 'Dommages et intérêts',
    loan: 'Prêt',
    logOut: 'Déconnexion',
    logoutConfirm: 'Voulez-vous vraiment vous déconnecter ?',
    margin: 'Profit attendu',
    myAccount: 'Mon compte',
    notification: 'Notification',
    notifications: 'Notifications',
    okay: 'OK',
    open: 'Ouvrir',
    openPrice: "Prix d'ouverture",
    openTime: "Heure d'ouverture",
    options: 'Règlement quantitatif',
    optionsOrder: 'Ordre de règlement quantitatif',
    order: 'Ordre',
    pips: 'Pips',
    profit: 'Bénéfice',
    putAway: 'Mettre de côté',
    receiveAddress: 'Adresse de réception',
    recreatePlan: 'Recréer le plan',
    refund: 'Remboursement',
    refundTip: 'Les fonds seront remboursés sur votre compte réel, veuillez vérifier.',
    repayNow: 'Rembourser maintenant',
    repayment: 'Remboursement',
    repaymentAmount: 'Montant du remboursement',
    repaymentDate: 'Date de remboursement',
    repeatOrder: 'Répéter cet ordre',
    reviewed: 'À examiner',
    runTime: "Durée d'exécution",
    save: 'Enregistrer',
    sell: 'VENDRE',
    settings: 'Paramètres',
    smart: 'Intelligent',
    startTime: 'Heure de début',
    staticincome: 'Revenus statiques',
    status: 'Statut',
    success: 'Succès',
    time: 'Temps',
    todayEarnings: 'Gains du jour',
    todayProfit: 'Profit du jour',
    totalInterest: 'Intérêts totaux',
    totalProfit: 'Profit total',
    totalRepayment: 'Remboursement total',
    totalRevenue: 'Revenu total',
    transFees: 'Frais de transaction',
    transRecord: 'Historique des transactions',
    transaction: 'Transaction',
    type: 'Type',
    up: 'Haut',
    withdraw: 'Retrait',
    withdrawNow: 'Retirer maintenant',
  },
  bangZhuZhongXin: "Centre d'aide",
  biaoDian: 'ponctuation',
  board: {
    content:
      'Ce logiciel répond à tous vos besoins de manière professionnelle avec la meilleure technologie',
    continue: 'Continuer',
    skip: 'Passer',
    title: 'La meilleure plateforme de trading',
  },
  bread: {
    introduction: 'Introduction',
  },
  chaKan: 'Vérifier',
  chongZhi: 'recharger',
  chongZhiJinexiaoYuZuiDiChongZhiJinE:
    'Le montant de la recharge est inférieur au montant minimum de la recharge',
  chongZhiPingZheng: 'Bon de recharge',
  chongZhiShiJian: 'Temps de recharge',
  chongZhiShuoMing: 'Instructions de recharge :',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    "Instructions de dépôt : le montant minimum du dépôt pour l'USDT est de 120, le montant minimum du dépôt pour le BTC est de 0,015 et le montant minimum du dépôt pour l'ETH est de 0,2.",
  close: 'Fermer',
  'customerService.error':
    'Le service client est temporairement indisponible. Veuillez réessayer plus tard.',
  'customerService.close': 'Fermer',
  'customerService.connected': 'Connecté',
  'customerService.imageAlt': 'Image du support client',
  'customerService.imagePreview': 'Aperçu de l’image',
  'customerService.imageTooLarge': 'La taille de l’image ne peut pas dépasser 5 Mo',
  'customerService.imageTypeUnsupported':
    'Seules les images PNG, JPEG ou WebP sont prises en charge',
  'customerService.imageUnavailable': 'Image indisponible',
  'customerService.loadFailed':
    "Le service client en ligne n'a pas pu être chargé. Veuillez réessayer plus tard.",
  'customerService.loading': 'Chargement…',
  'customerService.loginRequired': 'Veuillez vous connecter pour contacter le support',
  'customerService.openImage': 'Ouvrir l’image',
  'customerService.placeholder': 'Saisissez un message, appuyez sur Entrée pour envoyer',
  'customerService.send': 'Envoyer',
  'customerService.sendImage': 'Envoyer une image',
  'customerService.reconnecting': 'Reconnexion en cours',
  'customerService.title': 'Support',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    'La plupart des sites Web prennent des mesures pour protéger les informations personnelles des utilisateurs, par exemple en utilisant une technologie de cryptage pour protéger les mots de passe.',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    "La plupart des sites Web permettent aux utilisateurs de modifier leurs informations personnelles, comme changer leur adresse e-mail ou leur mot de passe. \nCependant, certaines informations ne peuvent pas être modifiées, comme le nom d'utilisateur.",
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    "Aucun intérêt n'est requis dans les {num} jours suivant la souscription du prêt, et les intérêts seront payés après {num} jours.",
  daiShenHe: "En attendant l'examen",
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    "Cependant, si le site Web ou l'application que vous utilisez présente une faille de sécurité, vos informations personnelles peuvent être exposées.",
  dangQiLiRun: 'Bénéfice pour la période en cours',
  dangQianLiXi: 'Intérêt actuel',
  daoQiHuanXiHuanBen: 'Rembourser les intérêts et le capital à l’échéance',
  daoQiShiJian: "Date d'expiration",
  dengLuChengGong: 'connexion réussie',
  di: 'Faible',
  dianHuaHaoMa: 'numéro de téléphone:',
  dieJiaLiShuai: 'Taux d’intérêt superposé :',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: 'haut',
  gouMai: 'Acheter',
  gouMaiChengGong: 'Achat réussi',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    "Les comptes en devises internationales contactent les services d'assistance en ligne pour la correspondance",
  home: {
    Application: 'Application',
    AvailableOnThe: "Disponible sur l'",
    CreditCard: 'Dépôt de cryptomonnaie',
    CreditCardInfo:
      'En utilisant la cryptomonnaie pour le dépôt, une couche de sécurité supplémentaire est obtenue et un traitement rapide des transactions est assuré.',
    CryptocurrenciesListed: 'Cryptomonnaies répertoriées',
    GetStarted: 'Commencer',
    NewFeaturesInOnline: 'Nouvelles fonctionnalités en ligne',
    NewFeaturesInOnlineInfo:
      'Découvrez les merveilleuses fonctionnalités de cette plateforme complète',
    RegisteredUsers: 'Utilisateurs enregistrés',
    allChains: 'All Chains',
    announcementClose: 'Fermer l’annonce',
    announcementLabel: 'Annonce',
    announcementView: 'Voir les détails',
    announcementAmount: 'Montant prêté',
    announcementAnnualRate: 'Rendement annuel',
    announcementBelowMinimum: 'Moins de {amount} USDT',
    announcementCompoundInterest: 'Intérêts composés',
    announcementCurrentConfig: 'Configuration actuelle',
    announcementEarningMode: 'Mode de calcul',
    announcementRateNotice:
      'Les gains suivent les paliers actuels de la plateforme. Les montants définitifs figurent dans les actifs et les relevés de règlement.',
    announcementRatesLoading: 'Chargement des paliers de rendement…',
    announcementSettlement: 'Heures de règlement quotidiennes',
    announcementSimpleInterest: 'Intérêts simples',
    announcementYieldEyebrow: 'Informations de rendement',
    announcementYieldIntro:
      'Un montant prêté plus élevé bénéficie d’un rendement annuel supérieur. Les montants sous le premier palier peuvent participer sans générer d’intérêts.',
    announcementYieldTitle: 'Détails du rendement actuel',
    appLicationInfo:
      'La banque mobile qui jette le livre de comptes et vous donne un outil de précision pour gérer vos finances.',
    billion: 'B',
    billionInfo: 'Volume de transactions moyen sur 24 heures',
    button1Title: 'Les frais de transaction les plus bas',
    button1Title1: 'Tradez tous les actifs en un lieu.',
    button1Title2: 'Forex, cryptomonnaies, actions, indices, matières premières',
    button2Title: "Taux d'intérêt bas et montant plus élevé",
    button2Title1: 'Prêts en cryptomonnaies',
    button2Title2: 'Empruntez des spots de cryptomonnaies sans aucune garantie',
    button3Title: 'Simple et stable',
    button3Title1: 'Trading intelligent',
    button3Title2: 'Un clic pour créer votre plan de gain',
    button4Title: 'Aidez les enfants du monde entier',
    button4Title1: 'NFTs caritatifs',
    button4Title2: "Achetez des œuvres NFT pour soutenir l'UNICEF",
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: 'Fournissez des liquidités au pool de prêt pour gagner des intérêts',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: 'Achetez & échangez 350+ cryptos sur la plateforme top.',
    loading: 'Loading...',
    million: 'M',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: 'Le portefeuille peut échanger BTC contre USD',
    noticeInfo1: 'Fonctionnez avec un compte de démonstration',
    periodDays: '{count} day | {count} days',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
  },
  huanKuanZhong: 'Remboursement en cours',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    'Bienvenue à utiliser notre plateforme de trading financier primée et à explorer le futur monde financier avec des investisseurs mondiaux !',
  jiXiShiJian: "Temps d'accumulation des intérêts",
  jiXuTouZi: 'Continuez à investir',
  jiangTuPianTuoFangDaoCiChuHuo: 'Faites glisser et déposez une image ici, ou',
  jieZhiShiJian: 'date limite',
  jiuMiMa: 'ancien mot de passe',
  juJueYuanYin: 'Motif du refus',
  kai: 'ouvrir',
  lendingAssets: {
    authorizedBalance: 'Solde autorise',
    availableAmount: 'Disponible au retrait',
    dailyOrders: 'Ordres de reglement quotidiens',
    dailyProfit: 'Gain quotidien',
    joinPool: 'Rejoindre un pool',
    loadMore: 'Charger plus',
    needAuth: 'Rejoignez un pool de pret pour voir vos soldes et gains',
    needLogin: 'Veuillez vous connecter pour voir vos actifs',
    noOrders: 'Aucun ordre de reglement',
    pageDesc:
      'Consultez les soldes autorises, les gains du pool et les ordres de reglement quotidiens',
    poolEarnings: 'Gains du pool de pret',
    todayEarnings: "Aujourd'hui",
    totalEarnings: 'Gains totaux',
    withdraw: 'Retrait',
    withdrawRecords: 'Historique des retraits',
    withdrawnAmount: 'Deja retire',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      "<p><strong>Version du document :</strong> V3.28 &nbsp;|&nbsp; <strong>Date de publication :</strong> 2022 &nbsp;|&nbsp; <strong>Type :</strong> Livre blanc produit et résumé d'évaluation de sécurité</p>\n\n<h2>1. Résumé exécutif</h2>\n<p>Ce module Lending Pool est un service de prêt et de liquidité on-chain construit sur des protocoles DeFi de marché monétaire. Grâce à des smart contracts open source et des modèles de taux programmatiques, le système connecte les actifs numériques des utilisateurs aux marchés de prêt on-chain établis, permettant <strong>des rendements sur dépôts, des emprunts garantis et le partage de liquidité</strong>.</p>\n<p>Le module ne repose pas sur une intervention manuelle pour l'allocation quotidienne des fonds. Les taux, capacités et taux d'utilisation sont déterminés en temps réel par les marchés on-chain et affichés de manière transparente via l'agrégation de données multi-sources.</p>\n\n<h2>2. Contexte sectoriel et positionnement</h2>\n<p>Le crédit traditionnel dépend d'institutions centralisées. Les protocoles DeFi utilisent des smart contracts pour faire correspondre automatiquement l'offre et la demande, avec sur-collatéralisation et mécanismes de liquidation.</p>\n<p>Positionnement de ce module :</p>\n<ul>\n  <li><strong>Passerelle vers les marchés monétaires on-chain :</strong> agrège les données de pools sur plusieurs chaînes et protocoles ;</li>\n  <li><strong>Distribution programmatique des rendements :</strong> règlement automatique selon un calendrier fixe basé sur les soldes autorisés et l'APY du marché ;</li>\n  <li><strong>Transparent et vérifiable :</strong> TVL, APY, utilisation et LTV traçables vers des données on-chain publiques ;</li>\n  <li><strong>Non custodial :</strong> l'autorisation et les interactions on-chain sont initiées depuis le portefeuille de l'utilisateur.</li>\n</ul>\n\n<h2>3. Architecture système</h2>\n<h3>3.1 Vue d'ensemble</h3>\n<ul>\n  <li><strong>Interface utilisateur :</strong> connexion wallet, autorisation, navigation des pools, consultation des gains ;</li>\n  <li><strong>Couche métier :</strong> authentification, gestion des autorisations, génération d'ordres de rendement, contenu multilingue ;</li>\n  <li><strong>Couche d'agrégation :</strong> synchronisation planifiée des métriques depuis des sources DeFi publiques ;</li>\n  <li><strong>Couche protocole on-chain :</strong> smart contracts de prêt audités exécutant la logique de dépôt et d'emprunt.</li>\n</ul>\n\n<h3>3.2 Métriques clés</h3>\n<table>\n  <thead>\n    <tr><th>Métrique</th><th>Description</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>Actifs totaux du pool en USD</td></tr>\n    <tr><td>Supply APY</td><td>Rendement annuel des dépôts (taux de base + récompenses)</td></tr>\n    <tr><td>Borrow APY</td><td>Coût annuel payé par les emprunteurs</td></tr>\n    <tr><td>Taux d'utilisation</td><td>Ratio des fonds empruntés sur fonds disponibles</td></tr>\n    <tr><td>Max LTV</td><td>Ratio prêt/valeur maximal avant liquidation</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>Limites par actif pour contrôler le risque de concentration</td></tr>\n    <tr><td>Liquidité disponible</td><td>Liquidité immédiatement empruntable</td></tr>\n  </tbody>\n</table>\n\n<h2>4. Parcours utilisateur et mécanisme de rendement</h2>\n<ol>\n  <li><strong>Connecter le wallet</strong> via Web3 ;</li>\n  <li><strong>Autoriser les actifs</strong> (USDT, USDC, etc.) par Approve on-chain ;</li>\n  <li><strong>Rejoindre le lending pool</strong> pour entrer dans la file de calcul des rendements ;</li>\n  <li><strong>Règlement des gains</strong> quotidien selon le solde autorisé et les taux du marché ;</li>\n  <li><strong>Consulter les actifs</strong> dans « Mon portefeuille ».</li>\n</ol>\n<p><strong>L'APY historique ne garantit pas les rendements futurs.</strong></p>\n\n<h3>4.3 Frais</h3>\n<h4>Comment sont facturés les frais DeFi Earn ?</h4>\n<p>Les transactions on-chain nécessitent des frais de gas pour interagir avec les smart contracts, y compris la souscription et la réclamation des gains. Pour certains actifs, le lending pool DeFi et les gestionnaires de vault peuvent prélever des frais de performance en pourcentage de vos profits réels ; votre capital n'est pas affecté.</p>\n\n<h2>5. Conception de la sécurité</h2>\n<ul>\n  <li>Protocoles sous-jacents audités en open source ;</li>\n  <li>Architecture non custodiale ; aucune clé privée stockée ;</li>\n  <li>Permissions Token Approve minimales ; révocables à tout moment ;</li>\n  <li>Authentification par token, HTTPS, RBAC admin et journaux d'audit.</li>\n</ul>\n\n<h2>6. Résumé de l'évaluation de sécurité</h2>\n<table>\n  <thead>\n    <tr><th>Élément</th><th>Résultat</th><th>Notes</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>Dépendances smart contract</td><td><strong>Validé</strong></td><td>Protocoles DeFi audités publiquement</td></tr>\n    <tr><td>Non custodial et gestion des clés</td><td><strong>Validé</strong></td><td>Aucun stockage de clé privée</td></tr>\n    <tr><td>API et authentification</td><td><strong>Validé</strong></td><td>Auth token et HTTPS en place</td></tr>\n    <tr><td>Synchronisation des données</td><td><strong>Validé</strong></td><td>Sync planifiée avec snapshots</td></tr>\n    <tr><td>Logique de règlement des gains</td><td><strong>Validé</strong></td><td>Règles explicites ; ordres auditable</td></tr>\n  </tbody>\n</table>\n\n<h2>7. Divulgation des risques</h2>\n<ul>\n  <li><strong>Risque smart contract :</strong> vulnérabilités non découvertes possibles ;</li>\n  <li><strong>Risque de marché :</strong> l'APY peut fluctuer fortement ;</li>\n  <li><strong>Risque de liquidation :</strong> baisse du collatéral pouvant déclencher une liquidation ;</li>\n  <li><strong>Risque de dépeg des stablecoins :</strong> USDT/USDC peut s'écarter de 1,00 $ ;</li>\n  <li><strong>Risque réglementaire :</strong> la régulation DeFi évolue mondialement.</li>\n</ul>\n<p><strong>Ce module ne fournit pas de conseil en investissement et ne garantit aucun rendement fixe.</strong></p>\n\n<h2>8. Glossaire</h2>\n<ul>\n  <li><strong>APY :</strong> rendement annuel en pourcentage ;</li>\n  <li><strong>TVL :</strong> valeur totale verrouillée ;</li>\n  <li><strong>LTV :</strong> ratio prêt/valeur ;</li>\n  <li><strong>Approve :</strong> autorisation de token ERC-20 ;</li>\n  <li><strong>Liquidation :</strong> vente automatique du collatéral en cas de sous-collatéralisation.</li>\n</ul>\n\n<p>— À titre informatif uniquement. Ne constitue pas un conseil juridique, financier ou en investissement. Vérifiez les données on-chain via les explorateurs de blocs et les interfaces officielles des protocoles.</p>",
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: "Veuillez vous connecter avant la vérification d'identité",
    needVerifyHint:
      "Veuillez compléter la vérification d'identité avant de rejoindre le pool de prêt",
    pageDesc: "Complétez la vérification d'identité pour rejoindre le pool de prêt",
    pendingHint: "Votre vérification d'identité est en cours d'examen. Veuillez patienter",
  },
  lendingMenu: {
    assets: 'Actifs',
    chooseDepositAsset: 'Choisir un actif à déposer',
    chooseDepositHint:
      'Déposez des actifs dans un pool de prêt pour générer des rendements et emprunter',
    copyUid: "Copier l'UID",
    customerService: 'Customer Service',
    depositAssetAction: 'Déposer {symbol}',
    earnings: 'Comment gagner',
    empty: 'Aucun contenu',
    explore: 'Explorer',
    footerDesc:
      'Un marché monétaire on-chain de nouvelle génération construit sur des contrats intelligents open source. Des règles programmatiques remplacent le contrôle manuel, offrant aux utilisateurs Web3 du monde entier des services de dépôt et de prêt de liquidités sûrs et transparents.',
    getStarted: 'Rejoindre maintenant',
    home: 'Accueil',
    identityVerification: "Vérification d'identité",
    intro: 'À propos',
    language: 'Langue',
    noAssetPool: 'Aucun pool de prêt trouvé pour cet actif',
    rulesSecurity: 'Rules & Security',
    security: 'Sécurité',
    theme: 'Apparence',
    uid: 'UID',
    whitepaper: 'Livre blanc',
    yieldLadder: 'Paliers de rendement',
  },
  lendingTheme: {
    auto: 'Système',
    dark: 'Sombre',
    light: 'Clair',
    title: 'Apparence',
  },
  lendingYieldLadder: {
    balance: "Capital d'un prêt individuel (USDT)",
    compoundInterest: 'Intérêt composé',
    earningMode: 'Mode de rendement : {mode}',
    empty: 'Aucun palier configuré',
    loading: 'Chargement des taux par palier…',
    noteFixed: 'Règlement quotidien au taux fixe de ce palier',
    noteRange: "Règlement quotidien à la borne supérieure de l'intervalle",
    notes: 'Remarques',
    rate: 'Plage de rendement quotidien',
    settlementHours: 'Heures de règlement configurées : {hours}',
    simpleInterest: 'Intérêt simple',
  },
  liangCiMiMaBuYiZhi: 'Deux mots de passe sont incohérents',
  loan: {
    Browse: 'Parcourir',
    address: 'Adresse :',
    birthdate: 'Date de naissance :',
    borrow: 'Emprunter',
    borrowNow: 'Emprunter maintenant',
    borrowPlaceholder: 'Je veux emprunter...',
    browse: 'parcourir',
    checkIn: 'Soumission réussie',
    confirm: 'Confirmer',
    continue: 'Continuer',
    country: 'Pays :',
    dailyRate: "Taux d'intérêt quotidien",
    days: 'Jours',
    document: 'Document :',
    done: 'Terminé !',
    driverLicense: 'permis de conduire',
    dropHere: 'Déposez votre image ici',
    ensure: 'Confirmer',
    female: 'Femme',
    firstName: 'Prénom :',
    idCard: "carte d'identité",
    inHand: 'en main',
    lastName: 'Nom :',
    launchCamera: "Lancer l'appareil photo",
    loanAgreement: 'Contrat de prêt',
    loanAmount: 'Montant du prêt',
    loanDetail: 'Détail du prêt',
    loanTerm: 'Durée du prêt',
    male: 'Homme',
    notVerifyBtn: 'Commencer la vérification',
    notVerifyTip: 'Vérifiez votre identité et obtenez un montant de prêt supérieur !',
    or: 'ou',
    passport: 'passeport',
    pendingReview: 'En attente de révision',
    phone: 'Numéro de téléphone :',
    phonePlaceholder: 'Entrez votre numéro de téléphone...',
    reSign: 'Resigner',
    resubmit: 'Soumettre à nouveau',
    sex: 'Femme / Homme :',
    sign: 'Signer',
    signTip: 'Veuillez confirmer et signer',
    signed: 'Signé',
    startVerfication: 'Démarrer la vérification',
    submit: 'Soumettre',
    supports: 'Supporte : JPG, JPEG2000, PNG',
    takePhoto: 'Prendre une photo',
    term: 'Durée du prêt (jours)',
    tipIdCardBack: "Placez le verso de la carte d'identité dans le cadre",
    tipIdCardFront: "Placez le recto de la carte d'identité dans le cadre",
    tipNotPass:
      "Nous sommes désolés que votre demande de KYC n'ait pas passé le processus de vérification. Veuillez soumettre à nouveau les documents d'application corrects pour finaliser la vérification KYC. Si vous avez des questions ou besoin d'aide, n'hésitez pas à contacter notre équipe de service clientèle à tout moment.",
    tipTakePhoto: 'Veuillez prendre une photo avec votre',
    tipVerifiedSuccess:
      'Félicitations ! Votre demande KYC a été vérifiée et vous pouvez désormais bénéficier de services de niveau supérieur.',
    tipWaitForResult:
      "Merci d'avoir soumis vos documents KYC. Notre équipe examinera vos informations dans les 48 heures. Veuillez patienter pendant l'attente des résultats.",
    title: 'Compte de prêt',
    totalAmount: 'Montant total des intérêts',
    verifiedSuccessfully: 'Vérifié avec succès',
    verifiedUnsuccessfully: 'Vérifié sans succès',
    verifyBtn: 'Vérifié avec succès',
    verifyTip: 'Obtenez un financement instantané pour sécuriser vos investissements !',
  },
  login: {
    btnContinueFacebook: 'Continuer avec Facebook',
    btnContinueGoogle: 'Continuer avec Google',
    btnLogin: 'Connexion',
    btnLoginFacebook: 'Connexion via Facebook',
    btnLoginGoogle: 'Connexion via Google',
    btnNext: 'Suivant',
    btnRecovery: 'Récupération',
    btnRecoveryPsd: 'Récupérer le mot de passe',
    btnRegister: "S'inscrire",
    btnRegisterFacebook: 'Inscription via Facebook',
    btnRegisterGoogle: 'Inscription via Google',
    btnSend: 'Envoyer',
    btnSignup: 'Inscription par e-mail',
    email: 'E-mail',
    emailPlaceholder: 'Saisissez votre e-mail, ex. name@example.com',
    emailTips: 'Cette adresse e-mail est déjà enregistrée.',
    hasAccount: 'Vous avez déjà un compte?',
    hasNotAccount: "Je n'ai pas de compte?",
    inputCode: 'Veuillez saisir le code de vérification',
    inputEmail: "Veuillez saisir l'adresse e-mail",
    inputPassword: 'Veuillez saisir le mot de passe',
    inputPhone: "Veuillez saisir l'adresse e-mail",
    inputUsernameOrEmail: 'Saisissez votre identifiant ou e-mail',
    labelEmail: 'Email :',
    labelEmailCode: 'Code de vérification:',
    labelPsd: 'Mot de passe :',
    labelPsdNew: 'Nouveau mot de passe :',
    labelPsdRepeat: 'Confirmer le mot de passe :',
    labelUsername: "Nom d'utilisateur :",
    labelUsernameOrEmail: 'Identifiant ou e-mail :',
    phone: 'Mail:',
    phoneTips: 'Cette adresse email a été enregistrée',
    starLogin: 'Commençons par la connexion !',
    starRegist: "Commençons par l'inscription !",
    starReset: 'Récupérons par e-mail !',
    tipRegisterContent:
      "Complétez votre inscription et déverrouillez la porte d'entrée vers un monde d'opportunités d'investissement passionnantes, ouvrant la voie au succès et à la croissance financière!",
    tipRegisterTitle: "Inscrivez-vous et lancez-vous dans votre voyage d'investissement prospère !",
    useEmailRegister: "S'inscrire avec un email",
    usePhoneRegister: "S'inscrire avec un numéro de téléphone",
    username: "nom d'utilisateur",
    usernameOptional: "Nom d'utilisateur (facultatif ; vide = e-mail)",
    usernameTips: 'Cet identifiant existe déjà!',
    welcome: 'Bienvenue sur',
  },
  navBottom: {
    bottomCompany: 'Société',
    bottomCompanyItem1: 'À propos de nous',
    bottomCompanyItem2: 'Supervision de licence',
    bottomCompanyItem3: "Centre d'aide",
    bottomCompanyItem4: 'Support en ligne',
    bottomOther: 'Déclarations',
    bottomOtherItem1: 'Informations légales',
    bottomOtherItem2: 'Avertissement',
    bottomOtherItem3: 'Avertissement de risque',
    bottomOtherItem4: 'Politique de cookies',
    bottomOtherItem5: 'À propos de la publicité',
    bottomPolicy: 'Politiques',
    bottomPolicyItem1: 'Termes et conditions',
    bottomPolicyItem2: 'Politique de confidentialité',
    bottomProduct: 'Produits',
    bottomProductItem1: 'Marchés',
    bottomProductItem2: 'Investissement et prêt',
    bottomProductItem3: 'NFT pour la charité',
    bottomProductItem4: 'Trading intelligent',
  },
  navTab: {
    btnLogin: 'Se connecter',
    btnSignup: "S'inscrire",
    language: 'Langue',
    languageTips: 'Choisissez une langue et une région',
    tabMenu1: 'Accueil',
    tabMenu2: 'Marché',
    tabMenu3: 'Trading intelligent',
    tabMenu4: 'Prêt',
    tabMenu5: 'NFT',
    tabMenu6: 'Compte',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: 'Le prix stop loss que vous avez entré est déraisonnable',
  ninShuRuDeZhiYingJiaGeBuHeLi: 'Le prix de take profit que vous avez saisi est déraisonnable',
  ntfs: {
    Address: 'Adresse',
    AllMoneyCharities:
      "Tout l'argent provenant de la vente de NFT est donné à des associations caritatives de l'UNICEF",
    BuyNFT: 'Achetez des œuvres NFT, aidez les enfants du monde entier!',
    BuyNow: 'Acheter',
    Chain: 'Chaîne',
    Confirm: 'Confirmer',
    Creator: 'Créateur',
    CumulativeDonation: 'Donation cumulative',
    CurrentBid: 'Offre actuelle',
    Markets: 'Marchés',
    MyNFTs: 'Mes NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'Détail des NFT',
    PlaceABid: 'Faire une offre',
    RemainingTime: 'Temps restant',
    Successful: 'Réussi',
    ThanksDonation: 'Merci pour votre don',
    Thisaddress: 'Cet article sera envoyé à votre adresse de portefeuille',
    Verified: 'Vérifié',
    andUNICEF: "et l'argent sera donné à l'UNICEF",
    charity: 'charité',
  },
  null: 'erreur inconnue',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: 'Veuillez passer au fonctionnement du compte réel',
  qingShangChuanPingZheng: 'Veuillez télécharger le certificat',
  qingShuRuDiZhi: "Veuillez entrer l'adresse",
  qingShuRuShouJiHao: 'veuillez saisir votre email',
  qingShuRuTouZiJinE: "Veuillez saisir le montant de l'investissement",
  qingShuRuYanZhengMa: 'veuillez entrer le code de vérification',
  qingShuRuZhengQueDeJinE: 'Veuillez saisir le montant correct',
  qingShuRuZhengQueDeYouXiang: 'veuillez entrer votre email valide',
  qingShuRuZhiSunJiaGe: 'Veuillez entrer le prix stop loss',
  qingShuRuZhiYingJiaGe: 'Veuillez saisir le prix du take profit',
  qingTianXieWanZhengXinXi: 'Veuillez remplir les informations complètes',
  qingZaiCiShuRuMiMa: 'Veuillez saisir à nouveau le mot de passe',
  queRenMiMa: 'Confirmez le mot de passe',
  repaySuccess: 'Remboursement réussi',
  ri: 'jour',
  riLiShuai: "Taux d'intérêt journalier :",
  search: {
    SearchHere: 'Recherchez ici',
  },
  shangChuanShiBaiQingZhongShi: 'Échec du téléchargement, veuillez réessayer',
  shenHeBuTongGuo: 'Audit non réussi',
  shou: 'recevoir',
  shouJiHao: 'Mail',
  shouXuFeiShiJiDaoZhangJinE: 'Frais de traitement/montant réel reçu',
  shouYiZhong: 'Revenu',
  shouYiZhuangTai: 'statut de revenu',
  shuRuNinDeDianHuaHaoMa: 'Entrez votre numéro de téléphone...',
  souSuo: 'recherche...',
  tiJiaoChengGong: 'Soumis avec succès',
  tiJiaoChongZhiPingZheng: 'Soumettre le bon de recharge',
  tiKuanFangShi: 'Méthode de retrait',
  tiXian: 'retirer',
  tiXianDiZhi: 'Adresse de retrait',
  tiXianShiJian: 'Délai de retrait',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    'Le retrait nécessite des frais de traitement de {rate} %, qui nécessitent une confirmation du nœud de réseau avant de pouvoir être déposé sur le compte. Veuillez ne pas transférer de crypto-monnaie à des étrangers.',
  toast: {
    UnreasonablePriceProfitLoss:
      "Fixation de prix déraisonnable pour la prise de profit et la perte d'arrêt",
    buyNumbers: "Veuillez entrer la quantité d'achat",
    copyError: 'Erreur de copie!',
    copySuccess: 'Copie réussie!',
    email: 'Veuillez saisir votre adresse e-mail',
    inputAll: "Les données d'entrée ne sont pas complètes",
    logOut: 'Déconnecté',
    noData: 'Plus de données',
    notAddress: "Veuillez entrer l'adresse",
    notAmount: 'Veuillez entrer le montant',
    notEmail: "Le format de l'e-mail est incorrect",
    notImage: "Le format de l'image est incorrect",
    notLoanAmount: 'Veuillez entrer le montant du prêt',
    notSigned: 'Non signé',
    notSmartAmount: 'Veuillez entrer le montant intelligent',
    notSupportMedia: "L'accès aux médias de l'utilisateur n'est pas pris en charge",
    notVerify: 'Veuillez effectuer la certification KYC',
    notWithdrawAmount: 'Veuillez entrer le montant à retirer',
    nothingfound: "Rien trouvé pour l'instant!",
    password: 'Veuillez entrer le mot de passe',
    passwordNotSame: 'Les mots de passe saisis ne correspondent pas',
    passwordRepeat: 'Veuillez confirmer votre mot de passe',
    uploadImage: "Veuillez télécharger l'image requise",
    userName: "Veuillez entrer le nom d'utilisateur",
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    "Habituellement, des informations de base telles que votre adresse e-mail, votre nom d'utilisateur, votre mot de passe et parfois des informations personnelles et vos coordonnées sont requises.",
  touZiShiJian: "temps d'investissement",
  touZiZhouQi: "cycle d'investissement",
  tuPianDaXiaoBuNengChaoGuo_2mb: "La taille de l'image ne peut pas dépasser 2 Mo !",
  tuPianDaXiaoBuNengChaoGuo_5m: "La taille de l'image ne peut pas dépasser 50 Mo !",
  uploadfailed: 'échec du téléchargement',
  usdtZuiDiChongZhiJinewei_120: 'Le montant minimum du dépôt de {name} est de {limit}',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    "La quantification automatique du trading Forex est une méthode qui utilise des programmes informatiques et des algorithmes pour exécuter automatiquement des stratégies de trading. \nCette méthode utilise des données historiques, des indicateurs techniques, des modèles statistiques et d'autres outils analytiques pour identifier les signaux de trading et exécuter automatiquement ces signaux lors de l'exécution des transactions. \nLa quantification automatisée des transactions Forex peut aider les traders à éliminer l'impact des émotions, à réduire les transactions erronées et à améliorer l'efficacité et la cohérence des transactions. \nCependant, la quantification automatisée des opérations de change présente également certains risques et limites potentiels. \nPar exemple, les programmes de trading automatisés peuvent ne pas être en mesure de s'adapter aux changements du marché, et la qualité et l'efficacité des programmes et algorithmes de trading dépendent en grande partie de la fiabilité et de la validité des données historiques. \nEn outre, le trading automatique peut également impliquer des risques techniques, tels qu'une panne informatique, une interruption du réseau, etc. Par conséquent, avant d'utiliser la quantification automatisée des opérations de change, les investisseurs doivent évaluer soigneusement leurs objectifs de trading, leur tolérance au risque et leurs capacités techniques, et choisir un partenaire fiable. Plateforme d'échanges . \nPlateformes de trading et programmes de trading automatisés. \nPlus important encore, les investisseurs doivent toujours faire preuve de prudence et prendre des mesures de gestion des risques appropriées pour protéger leurs investissements.",
  wallet: {
    activate: 'Activer',
    authFailed: "Échec de l'autorisation",
    authSuccess: 'Autorisation réussie',
    authorized: 'Autorisé',
    connectFailed: 'Échec de la connexion au portefeuille',
    connectWallet: 'Connecter le portefeuille',
    connecting: 'Connexion en cours...',
    justCanWallet: "Ce site n'accepte l'accès que via des Dapps décentralisées",
    networkNotSupported:
      "Le réseau actuel n'est pas pris en charge, veuillez passer à un réseau pris en charge",
    noWalletDetected: 'Aucun portefeuille détecté. Veuillez installer MetaMask ou TronLink.',
    pleaseConnectWallet: 'Veuillez connecter votre portefeuille',
    status: 'État du portefeuille',
    testnetDisabled: 'Le réseau de test est désactivé, veuillez utiliser le réseau principal',
    transactionCancelled: 'Transaction annulée',
    unauthorized: 'Non autorisé',
    userCancelled: "L'utilisateur a annulé l'opération",
  },
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    "Délai d'expiration du réseau, veuillez accéder à la liste des commandes pour afficher la commande",
  weiKaiQiZhiNengJiaoYi: "Le trading intelligent n'est pas activé",
  weiRenZheng: 'non certifié',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: 'Pourquoi dois-je créer un compte ?',
  weiTongGuo: "N'a pas passé",
  woDeZhuCeXinXiHuiBeiBaoMiMa: 'Mes informations d’inscription resteront-elles confidentielles ?',
  woKeYiGengGaiWoDeZhuCeXinXiMa: "Puis-je modifier mes informations d'inscription ?",
  woKeYiZhuCeDuoGeZhangHuMa: 'Puis-je enregistrer plusieurs comptes ?',
  xiaCiShouYiShiJian: 'Prochaine période de gains',
  xiaDanChengGong: 'commandé avec succès',
  xinGongNengShangXian: 'Les nouveautés sont en ligne !',
  xinMiMa: 'nouveau mot de passe',
  yanShiZhangHaoBuNengShiYongGaiGongNeng:
    'Les comptes démo ne peuvent pas utiliser cette fonctionnalité',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi:
    'Les comptes démo ne peuvent pas utiliser le trading intelligent',
  yanShiZhangHuYiJinYong: 'Compte démo désactivé',
  yiDaoQi: 'être expiré',
  yiFenRun: 'Le bénéfice a été divisé',
  yiFenRunTianShu: "Nombre de jours d'intéressement",
  yiHuanKuan: 'Remboursé',
  yiJuJue: 'rejeté',
  yiQieHuanWeiXuNiZhangHu: 'Passé au compte virtuel',
  yiQieHuanWeiZhenShiZhangHu: 'Passé au compte réel',
  yiRenZheng: 'vérifié',
  yiWanCheng: 'complété',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    "Certains sites Web peuvent permettre aux utilisateurs d'enregistrer plusieurs comptes, mais la plupart des sites Web n'autorisent chaque utilisateur qu'à créer un seul compte. \nSi vous tentez d'enregistrer plusieurs comptes, votre compte peut être banni ou supprimé.",
  zhangFu: 'Augmenter',
  zhenFu: 'amplitude',
  zhuCeChengGong: "succès de l'inscription",
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    "L'enregistrement d'un compte vous permet d'utiliser les fonctionnalités du site ou de l'application plus facilement et protège vos informations personnelles.",
  zhuCeZhangHuXuYaoShiMoXinXi: 'Quelles informations sont nécessaires pour créer un compte ?',
  zongLiXi: 'intérêt total',
  zuiDiJia: 'prix le plus bas',
}
